import React from 'react';

import { useSnackBarMessage } from '@waypoint/react/notifications';

export default function SnackbarManager() {
  const snackbarMessage = useSnackBarMessage();
  return <>{snackbarMessage}</>;
}
